import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=a9e43648&scoped=true&"
var script = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=a9e43648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e43648",
  null
  
)

export default component.exports